module.exports = {
    publicPath: process.env.NODE_ENV == 'production' ? "/smart/" : '/',
    devServer: {
      disableHostCheck: true
    }
}
